import { FMT } from '@/helpers/DateService';
import { Dayjs } from 'dayjs';
import Vue from 'vue';
export default Vue.extend({
    name: 'DateTextEdit',
    model: {
        prop: 'date',
        event: 'input'
    },
    props: {
        date: {
            type: String,
            default: ''
        },
        label: { type: String, default: '' },
        icon: { type: String, default: '' },
        outlined: { type: Boolean, default: false },
        dense: { type: Boolean, default: false },
        disabled: {
            type: Boolean,
            default: false
        },
        min: {
            type: Dayjs,
            default: null
        },
        max: {
            type: Dayjs,
            default: null
        },
        between: {
            type: String,
            default: null
        },
        onlyDate: {
            type: Boolean,
            default: false
        },
        showSeconds: {
            type: Boolean,
            default: false
        },
        notPast: {
            type: Boolean,
            default: false
        },
        notFuture: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        internalValue: {
            get() {
                return this.date ?? '';
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        allRules() {
            const rules = [];
            const length = this.onlyDate
                ? 10
                : this.showSeconds
                    ? 19
                    : 16;
            rules.push((v) => (!v || v.length === length) || 'Fecha inválida.');
            rules.push(this.isDateValid);
            if (this.required) {
                rules.push((v) => !!v || 'Campo obligatorio.');
            }
            if (this.min) {
                rules.push(this.isDateAfterThan);
            }
            if (this.max) {
                rules.push(this.isDateBeforeThan);
            }
            if (this.between) {
                rules.push(this.isDateBetween);
            }
            if (this.notPast) {
                rules.push(this.isDatePast);
            }
            if (this.notFuture) {
                rules.push(this.isDateFuture);
            }
            return rules;
        },
        dateFormat() {
            if (this.onlyDate)
                return FMT.onlyDate;
            if (this.showSeconds)
                return FMT.display;
            return FMT.date;
        },
        mask() {
            if (this.onlyDate)
                return '##/##/####';
            if (this.showSeconds)
                return '##/##/#### ##:##:##';
            return '##/##/#### ##:##';
        },
        facade() {
            if (this.onlyDate)
                return '##/##/####';
            if (this.showSeconds)
                return '##/##/#### ##:##:##';
            return '##/##/#### ##:##';
        }
    },
    watch: {
        min() {
            this.$refs.input?.validate?.();
        },
        max() {
            this.$refs.input?.validate?.();
        },
        between() {
            this.$refs.input?.validate?.();
        }
    },
    methods: {
        isDateValid(v) {
            if (!v)
                return true;
            return this.$date.toDayjs(v, this.dateFormat).isValid() || 'Fecha inválida.';
        },
        isDateAfterThan(v) {
            if (v && this.min) {
                const date = this.$date.toDayjs(v, this.dateFormat);
                const dayjsMin = typeof this.min === 'string' ? this.$date.toDayjs(this.min, this.dateFormat) : this.min;
                return date.isAfter(dayjsMin) || 'La fecha se sale de los límites.';
            }
            return true;
        },
        isDateBeforeThan(v) {
            if (v && this.max) {
                const date = this.$date.toDayjs(v, this.dateFormat);
                const dayjsMax = typeof this.max === 'string' ? this.$date.toDayjs(this.max, this.dateFormat) : this.max;
                return date.isBefore(dayjsMax) || 'La fecha se sale de los límites.';
            }
            return true;
        },
        isDateBetween(v) {
            if ((!v || v === '') && this.between) {
                return 'La fecha es requerida.';
            }
            return true;
        },
        isDatePast(v) {
            if (!v)
                return true;
            const now = this.$date.getCurrentDayJs();
            const dLocal = this.$date.toDayjs(v, this.dateFormat);
            if (!dLocal.isValid())
                return 'Fecha inválida.';
            return !dLocal.isBefore(now) || 'La fecha no puede ser anterior a ahora';
        },
        isDateFuture(v) {
            if (!v)
                return true;
            const now = this.$date.getCurrentDayJs();
            const dLocal = this.$date.toDayjs(v, this.dateFormat);
            if (!dLocal.isValid())
                return 'Fecha inválida.';
            return !dLocal.isAfter(now) || 'La fecha no puede ser a futuro.';
        },
        isValid() {
            const v = this.internalValue;
            const rules = this.allRules;
            for (let i = 0; i < rules.length; i++) {
                const res = rules[i](v);
                if (res !== true)
                    return false;
            }
            return true;
        },
        onFocus(event) {
            this.$emit('focus', event);
        }
    }
});
